<template lang="pug">
  DefaultLayout
    CommonSection(title="Рефералы")
      .b-affiliate-referrals-page
        ._tabs
          AffiliateTabs
        BaseInput._search(v-model="nameFilter" label="Поиск реферала")
        FormBlock._main
          BaseTable._table(:headers="$options.headers" :items="items" v-slot="{ items, headers, sort }")
            ._row(v-for="item in items" :key="item.id")
              ._cell
                router-link(:to="{ name: 'affiliate-referral', params: { referralId: item.id } }")
                  UserTile(:user="item")
                BaseTableHeaderItem._header(v-bind="headers[0]" @sort="sort")
              ._cell {{ formatDate(item.createdAt) }}
                BaseTableHeaderItem._header(v-bind="headers[1]" @sort="sort")
              ._cell {{ item.paymentsSum / 100 }} ₽
                BaseTableHeaderItem._header(v-bind="headers[2]" @sort="sort")
              ._cell.-bold {{ Math.floor(item.paymentsSum * 0.3) / 100  }} ₽
                BaseTableHeaderItem._header(v-bind="headers[3]" @sort="sort")
              ._cell.-bold(:class="[ item.status ]") {{ $options.statuses[item.status] }}
                BaseTableHeaderItem._header(v-bind="headers[4]" @sort="sort")
        FormBlock._aside
          ._aside-title Фильтры
          BaseInput._search2(v-model="nameFilter" label="Поиск реферала")
          BaseSelect._aside-status(v-model="statusFilter" label="Статус" :options="Object.entries($options.statuses).map(([value, label]) => ({ value, label }))")
          BaseCheckbox._aside-checkbox(v-model="hideReferralsWithoutPayments" label="Скрыть рефералов без платежей")
          BaseCheckbox._aside-checkbox(v-model="hideBlockedReferrals" label="Скрыть заблокированных рефералов")
          ._aside-hint Вы получаете 30% с платежей всех рефералов.
</template>

<script>
import utils from '@/utils/common';

import DefaultLayout from '@/layouts/Default.vue';
import CommonSection from '@/components/CommonSection.vue';
import BaseTable from '@/components/base/BaseTable.vue';
import BaseTableHeaderItem from '@/components/base/BaseTableHeaderItem.vue';
import FormBlock from '@/components/FormBlock.vue';
import UserTile from '@/components/UserTile.vue';
import BaseInput from '@/components/BaseInput.vue';
import AffiliateTabs from '@/components/affiliate/AffiliateTabs.vue';
import BaseCheckbox from '@/components/BaseCheckbox.vue';
import BaseSelect from '@/components/BaseSelect.vue';

export default {
  name: 'PersonalAffiliateReferralsPage',
  components: {
    BaseSelect,
    BaseCheckbox,
    AffiliateTabs,
    BaseInput,
    UserTile,
    FormBlock,
    DefaultLayout,
    CommonSection,
    BaseTable,
    BaseTableHeaderItem,
  },
  headers: [
    { title: 'Рефералы', sortFn: (a, b) => `${a.name} ${a.surname}`.localeCompare(`${b.name} ${b.surname}`) },
    { title: 'Регистрация', sortFn: (a, b) => a.createdAt - b.createdAt, defaultSort: true },
    { title: 'Платежи', sortFn: (a, b) => a.paymentsSum - b.paymentsSum },
    { title: 'Прибыль', sortFn: (a, b) => a.paymentsSum - b.paymentsSum },
    { title: 'Статус' },
  ],
  statuses: {
    active: 'Активный',
    blocked: 'Заблокирован',
    notConfirmed: 'Не подтвержден',
  },
  data() {
    return {
      nameFilter: '',
      statusFilter: null,
      hideBlockedReferrals: false,
      hideReferralsWithoutPayments: false,
    };
  },
  created() {
    this.$store.dispatch('affiliate/fetch');
  },
  computed: {
    items() {
      return this.$store.getters['affiliate/referrals']
        .filter(
          r => (
            !this.nameFilter
            || r.name.toLowerCase().includes(this.nameFilter.toLowerCase())
            || r.surname.toLowerCase().includes(this.nameFilter.toLowerCase())
          )
            && (!this.hideBlockedReferrals || r.status !== 'blocked')
            && (!this.hideReferralsWithoutPayments || r.paymentsSum > 0)
            && (!this.statusFilter || r.status === this.statusFilter),
        );
    },
  },
  methods: {
    formatDate(date) {
      return utils.convertDateToString(date);
    },
  },
};
</script>

<style scoped lang="scss">
  .affiliate-referrals-page {
    display: grid;
    grid-template-columns: 1fr 280px;
    gap: 35px;
    align-items: start;

    &__row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 10px;
    }

    &__cell {
      &--bold {
        font-weight: 500;
      }

      &.blocked { color: #F17275; }
      &.active { color: #5AC169; }
      &.notConfirmed { color: #FED101; }
    }

    ::v-deep .cell, &__cell {
      text-align: center;
      justify-content: center;

      &:nth-child(1) {
        text-align: left;
        justify-content: flex-start;
      }

      &:nth-child(1) { width: 30%; }
      &:nth-child(2) { width: 15%; }
      &:nth-child(3) { width: 20%; }
      &:nth-child(4) { width: 20%; }
      &:nth-child(5) { width: 15%; }
    }

    &__header {
      display: none;
    }

    &__cell ::v-deep .name {
      color: #33A1FB;
      font-weight: 500;
    }

    &__search2 {
      display: none;
    }

    &__aside {
      display: flex;
      flex-direction: column;
      gap: 10px;
    }

    &__aside-title {
      font-weight: 500;
      font-size: 18px;
      line-height: 24px;
      color: #232226;
      border-bottom: 1px solid #EBEFF2;
      padding-bottom: 12px;
    }

    &__aside-status {
      margin: 15px 0;
    }

    &__aside-checkbox ::v-deep .label {
      font-weight: 400;
      font-size: 14px;
      line-height: 18px;
      color: #1E3147;
    }

    &__aside-hint {
      background: #D3EAFF;
      border-radius: 8px;
      font-weight: 400;
      font-size: 12px;
      line-height: 15px;
      color: #1E3147;
      padding: 15px;
      margin-top: 15px;
    }

    @media (max-width: 1250px) {
      grid-template-columns: 1fr;

      &__tabs {
        order: 1;
      }

      &__aside {
        order: 2;
        background: transparent;
        padding: 0;
        box-shadow: none;
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 20px;
      }

      &__main {
        order: 3;
      }

      &__search {
        display: none;
      }

      &__search2 {
        display: block;
      }

      &__aside-title {
        display: none;
      }

      &__aside-status {
        margin: 0;
      }

      &__aside-hint {
        grid-column: 1 / 2 span;
      }
    }

    @media (max-width: 1000px) {
      &__main {
        background: transparent;
        padding: 0;
        box-shadow: none;
      }

      &__header {
        display: flex;
      }

      &__table ::v-deep .header {
        display: none;
      }

      &__table ::v-deep .body {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 20px;
      }

      &__row {
        &, &:nth-child(odd) {
          background: #FFFFFF;
          border-radius: 8px;
          padding: 12px 18px 22px;
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 20px;
        }
      }

      ::v-deep .cell, &__cell {
        width: auto !important;
      }

      &__cell {
        display: flex;
        flex-direction: column-reverse;
        justify-self: flex-start;
        align-items: flex-start;
        gap: 5px;

        &:first-child {
          grid-column: 1 / 2 span;
          padding-bottom: 20px;
          border-bottom: 1px solid #EBEFF2;
          justify-self: stretch;
          gap: 10px;
        }
      }
    }

    @media (max-width: 576px) {
      &__tabs {
        overflow-x: scroll;
      }

      &__table ::v-deep .body {
        grid-template-columns: 1fr;
      }

      &__aside {
        grid-template-columns: 1fr;
      }

      &__aside-hint {
        grid-column: 1 / 1 span;
      }
    }
  }
</style>
